import React from "react";
import Confetti from "react-confetti";
import { Container, Row, Col } from "react-bootstrap";

const ComingSoon = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "white",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column", // Ensure vertical alignment
        textAlign: "center", // Center text horizontally
      }}
    >
      {/* Confetti Animation */}
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        numberOfPieces={300}
        recycle={false}
      />
      <Container>
        <Row>
          <Col xs={12}>
            {/* Title */}
            <h1
              style={{
                fontSize: "clamp(2.5rem, 5vw, 4rem)",
                fontWeight: "bold",
                color: "#333",
                marginBottom: "1rem",
              }}
            >
              Coming Soon
            </h1>
            {/* Subtitle */}
            <p
              style={{
                fontSize: "clamp(1rem, 3vw, 1.5rem)",
                color: "#555",
                margin: "0 1rem",
                lineHeight: "1.5",
              }}
            >
              I'm working hard to bring this project to life! 
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ComingSoon;
